
import appCan from 'bits/app_can'
import { recordWhitelistedClick } from 'bits/pepin'
import { Action, Component, defineAsyncComponent, Getter, namespace, State, Vue } from 'bits/vue'
import type { Cid, Post } from 'types'
import SurfaceContentPicker from 'vuecomponents/content_picker.vue'

@Component({
  components: {
    SurfaceContentPicker,
    SurfaceAddPostButton: defineAsyncComponent(() => import('vuecomponents/SurfaceAddPostButton.vue')),
    SurfaceSectionPicker: defineAsyncComponent(() => import('vuecomponents/surface_section_picker.vue')),
  },
})
export default class SurfaceAddPost extends Vue {
  recordWhitelistedClick = recordWhitelistedClick

  @State isEmbedded!: boolean
  @State isReadOnly!: boolean
  @Getter canIWrite!: boolean
  @Getter dir!: 'ltr' | 'rtl'
  @Getter isApp!: boolean
  @Getter isAPanelVisible!: boolean
  @Getter isDesktop!: boolean
  @Getter isPhone!: boolean
  @Getter isShelf!: boolean
  @Getter isTable!: boolean
  @Getter canUseSections!: boolean
  @Getter xMobileSurfaceLayoutV3!: boolean
  @Action showOverFileSizeModal!: (payload: { file: any }) => void
  @namespace('browser').State darkMode!: boolean | 'auto'
  @namespace('composerModal').Getter('isDocked') isComposerModalDocked!: boolean
  @namespace('draft').Getter isActiveDraftNewPost!: boolean
  @namespace('post').Getter pendingPosts!: Post[]
  @namespace('post').Getter postBeingEditedCid!: Cid

  get canShowAddPost(): boolean {
    const isAppWithNewPosting = this.isApp && appCan('newPostModal')
    const isActiveDraftDocked =
      this.isComposerModalDocked && this.isActiveDraftNewPost && this.isDesktop && !this.isPhone
    const isAPostBeingEdited = !!this.postBeingEditedCid
    return (
      !isAppWithNewPosting &&
      (this.isEmbedded || !this.xMobileSurfaceLayoutV3) &&
      this.canIWrite &&
      !this.isReadOnly &&
      !this.isAPanelVisible &&
      (!isAPostBeingEdited || isActiveDraftDocked)
    )
  }

  get xAddPostButton(): boolean {
    return this.canShowAddPost && !this.isTable && !this.isShelf
  }

  get xSectionPicker(): boolean {
    if (this.isShelf || this.canUseSections) {
      const pendingPostsWithoutSections = this.pendingPosts.filter((p: Post) => !p.wall_section_id)
      return pendingPostsWithoutSections.length > 0
    }
    return false
  }
}
